import partyActions from "../VotifyParty/partyActions";
import hostActions from "./hostActions";
import playbackActions from "../VotifyPlayback/playbackActions";

const initialState = {
  isHost: false,
  partyId: "",
  hasDevice: false,
  isAuthorized: true,
  timeOfLastPlayback: Date.now(), // Is it ok to not be pure functional is initialState?
  availableDevices: [],
  selectedPlaylists: [],
  welcomeMenuIsSeen: false,
  jwtToken: "",
};

export const STATE_KEY = "host";

const hostReducer = (state = initialState, action) => {
  switch (action.type) {
    case partyActions.CREATE_PARTY:
      return {
        // Reset some stuff about the party. Might move this to other reducer.
        ...initialState,
        jwtToken: state.jwtToken,
        isHost: true,
        partyId: action.payload.id,
      };
    case hostActions.NO_DEVICE:
      return {
        ...state,
        hasDevice: false,
      };
    case hostActions.NOT_AUTHORIZED:
      return {
        ...state,
        isAuthorized: false,
      };
    // LOAD_PLAYBACK indicates that the server could send a playback which means it has a device
    case playbackActions.LOAD_PLAYBACK:
      return {
        ...state,
        timeOfLastPlayback: action.payload.playback.timestamp, // playbacks have a timestamp
        hasDevice: true,
        isAuthorized: true,
      };
    case hostActions.SAVE_JWT_TOKEN:
      return {
        ...state,
        jwtToken: action.payload.jwtToken,
      };
    case hostActions.SUCCESS_SELECT_DEVICE_REQUEST:
      return {
        ...state,
        selectedDevice: action.payload.device,
      };
    case hostActions.LOAD_DEVICES:
      return {
        ...state,
        availableDevices: action.payload.devices,
      };
    case hostActions.START_SET_PLAYLIST_REQUEST:
      return {
        ...state,
        currentlyLoadingPlaylistId: action.payload.playlist.id,
      };
    case hostActions.END_SET_PLAYLIST_REQUEST:
      return {
        ...state,
        currentlyLoadingPlaylistId: "",
      };
    case hostActions.LOAD_PRIVATE_CREDENTIALS:
      return {
        ...state,
        privateCredentials: action.payload.credentials,
      };
    case hostActions.SUCCESS_LOAD_PLAYLISTS_REQUEST:
      return {
        ...state,
        playlists: action.payload,
      };
    case hostActions.SUCCESS_SET_PLAYLIST_REQUEST:
      return {
        ...state,
        selectedPlaylists: [
          ...state.selectedPlaylists,
          action.payload.playlist,
        ],
      };
    case hostActions.SET_WELCOME_MENU_SEEN:
      return {
        ...state,
        welcomeMenuIsSeen: true,
      };
    default:
      return state;
  }
};

export default hostReducer;
